import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PersonItem, PersonSearchOptions } from '@models/custom-fields.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { PersonService } from '@services/person/person.service';
import {
  Observable,
  OperatorFunction,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  switchMap,
  tap
} from 'rxjs';
import { DomSanitizerPipe, TdsTypeAheadComponent } from 'tangoe-design-system';

@Component({
  selector: 'ts-person-select',
  templateUrl: './person-select.component.html',
  imports: [CommonModule, DomSanitizerPipe, TranslationPipe, TdsTypeAheadComponent]
})
export class PersonSelectComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() name: string;
  @Input() help_text?: string;
  @Input() required: boolean = false;
  @Input() control: FormControl;
  @Input() header_text?: string;

  no_results_found: boolean = false;
  loading: boolean = false;
  input_format = (item: PersonItem) => item.display_value;

  constructor(private person_service: PersonService) {}

  search: OperatorFunction<string, readonly Partial<PersonItem>[]> = (term$: Observable<string>) =>
    term$.pipe(
      debounceTime(100),
      tap(() => (this.loading = this.no_results_found = false)),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term.length < 3) return of([]);

        this.loading = true;
        return this.person_service.search(term).pipe(
          map((response: PersonSearchOptions) => {
            this.loading = false;

            if (response.items.length > 0) {
              return response.items.map((item: PersonItem) => ({
                ...item,
                display_value: `${item.person_name} (${item.email})`
              }));
            }

            this.no_results_found = true;
            return [];
          }),
          catchError(() => {
            this.loading = false;
            return of([]);
          })
        );
      })
    );
}
